import { useQuery } from '@tanstack/react-query';
import apiClient from '@/lib/api/apiClient';
import { DashboardQuerystring, InvestorDashboardResponse } from '@inversor-hub/types';

export const DASHBOARD_KEY = 'dashboard';

export function useDashboard(period: Required<DashboardQuerystring>) {
  return useQuery({
    queryKey: [DASHBOARD_KEY, period],
    queryFn: async () => {
      return apiClient.get<InvestorDashboardResponse>('/dashboard', { params: period });
    },
    placeholderData: (previousData) => previousData,
    select: (response) => response.data,
  });
}
